import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { CheckCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useNavigation } from "../contexts/NavigationContext";

// const VerificationSuccess = () => {
//   const [showMessage, setShowMessage] = useState(false);
//   const navigate = useNavigate();
//   const { hasSubmittedVideo } = useNavigation();

//   useEffect(() => {
//     // First check if user should be here
//     if (!hasSubmittedVideo) {
//       navigate("/", { replace: true });
//       return; // Exit early if unauthorized
//     }

//     // If authorized, handle message animation
//     const messageTimer = setTimeout(() => {
//       setShowMessage(true);
//     }, 1500);

//     // Cleanup
//     return () => {
//       clearTimeout(messageTimer);
//     };
//   }, [hasSubmittedVideo, navigate]);

//   // Don't render anything until we confirm authorization
//   if (!hasSubmittedVideo) {
//     return null;
//   }

//   return (
//     <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center">
//       <motion.div
//         initial={{ scale: 0 }}
//         animate={{ scale: 1 }}
//         transition={{
//           type: "spring",
//           stiffness: 260,
//           damping: 20,
//         }}
//       >
//         <CheckCircle className="w-32 h-32 text-green-500" />
//       </motion.div>

//       <motion.div
//         initial={{ opacity: 0, y: 50 }}
//         animate={{ opacity: showMessage ? 1 : 0, y: showMessage ? 0 : 50 }}
//         transition={{ duration: 0.5 }}
//         className="mt-8 text-center"
//       >
//         <h1 className="text-3xl font-bold text-gray-800 mb-2">
//           Video Submitted Successfully!
//         </h1>
//         <p className="text-xl text-gray-600">
//           Thank you for recording your consent.
//         </p>
//       </motion.div>
//     </div>
//   );
// };

// export default VerificationSuccess;
const VerificationSuccess = () => {
  const [showMessage, setShowMessage] = useState(false);
  const navigate = useNavigate();
  const { hasSubmittedVideo } = useNavigation();
  const BOT_URL = "https://t.me/behookedai_bot";

  useEffect(() => {
    // First check if user should be here
    if (!hasSubmittedVideo) {
      navigate("/", { replace: true });
      return;
    }

    // Show success message
    const messageTimer = setTimeout(() => {
      setShowMessage(true);

      // After showing message, redirect to Telegram bot
      const redirectTimer = setTimeout(() => {
        window.location.href = BOT_URL;
      }, 3000); // Redirect after 3 seconds

      // Clean up redirect timer
      return () => clearTimeout(redirectTimer);
    }, 1500);

    // Clean up message timer
    return () => clearTimeout(messageTimer);
  }, [hasSubmittedVideo, navigate]);

  // Don't render anything until we confirm authorization
  if (!hasSubmittedVideo) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center">
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{
          type: "spring",
          stiffness: 260,
          damping: 20,
        }}
      >
        <CheckCircle className="w-32 h-32 text-green-500" />
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: showMessage ? 1 : 0, y: showMessage ? 0 : 50 }}
        transition={{ duration: 0.5 }}
        className="mt-8 text-center space-y-4"
      >
        <h1 className="text-3xl font-bold text-gray-800 mb-2">
          Video Submitted Successfully!
        </h1>
        <p className="text-xl text-gray-600">
          Thank you for recording your consent.
        </p>
        <p className="text-lg text-gray-600">Redirecting you to Telegram...</p>
        <motion.button
          initial={{ opacity: 0 }}
          animate={{ opacity: showMessage ? 1 : 0 }}
          className="mt-4 px-6 py-2 bg-gradient-to-b from-black to-[#353535] text-white rounded-full hover:opacity-90 transition-opacity"
          onClick={() => (window.location.href = BOT_URL)}
        >
          Continue to Telegram
        </motion.button>
      </motion.div>
    </div>
  );
};
export default VerificationSuccess;
